/**
 * Application constants – route names, labels, and static config.
 */

import type { UserRole } from '@/types'

export const ROUTE_NAMES = {
  LOGIN: 'login',
  DASHBOARD: 'dashboard',
  STYLE_PROFILING: 'style-profiling',
  NEWS_INPUT: 'news-input',
  CONTENT_GENERATION: 'content-generation',
  PUBLISHING: 'publishing',
  CONTENT_ARCHIVE: 'content-archive',
  USER_MANAGEMENT: 'user-management',
  PRESENTATION: 'presentation',
} as const

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Yönetici',
  editor: 'Editör',
  writer: 'Yazar',
}

export const SITE_IDS = ['samanyolu', 'aktif', 'bold'] as const
export type SiteId = (typeof SITE_IDS)[number]

export const SITE_OPTIONS: { id: SiteId; name: string }[] = [
  { id: 'samanyolu', name: 'Samanyolu Haber' },
  { id: 'aktif', name: 'Aktif Haber' },
  { id: 'bold', name: 'Bold Medya' },
]

export const SITE_LABELS: Record<string, string> = Object.fromEntries(
  SITE_OPTIONS.map((s) => [s.id, s.name])
)

export const DEFAULT_SITE_LABEL = 'Samanyolu Haber'
